import { Loader2, CheckCircle2, AlertCircle } from 'lucide-react';

/**
 * LoadingIndicatorView - Reusable loading/syncing indicator UI primitive
 * Shows non-intrusive status indicator with configurable position and message
 *
 * Props:
 * - count: Number of concurrent operations (hides when 0)
 * - message: Text to display (default: "Syncing...")
 * - status: Current status ('loading' | 'saving' | 'syncing' | 'error' | 'success')
 */
export default function LoadingIndicatorView({ 
  count = 0, 
  message = 'Syncing...', 
  status = 'loading' 
}) {
  if (count === 0) return null;

  // Icon based on status
  const Icon = {
    loading: Loader2,
    saving: Loader2,
    syncing: Loader2,
    error: AlertCircle,
    success: CheckCircle2,
  }[status] || Loader2;

  // Animation class
  const iconClassName = {
    loading: 'animate-spin',
    saving: 'animate-spin',
    syncing: 'animate-spin',
    error: '',
    success: '',
  }[status] || 'animate-spin';

  // Color based on status
  const iconColor = {
    loading: 'text-primary',
    saving: 'text-primary',
    syncing: 'text-primary',
    error: 'text-destructive',
    success: 'text-green-500',
  }[status] || 'text-primary';

  return (
    <div className="flex items-center gap-1.5 rounded-full bg-background/90 px-2 py-1 shadow-lg backdrop-blur-sm border border-border opacity-80">
      <Icon className={`h-2.5 w-2.5 ${iconClassName} ${iconColor}`} />
      <span className="text-[10px] font-medium text-foreground">{message}</span>
    </div>
  );
}
